import { FlexLayout, H4 } from '@deity/falcon-ui';
import type { FC } from 'react';
import { ContentType, Host, Protocol } from './Properties';

interface ConfigurationProps {
  isEditable: boolean;
  protocol?: 'http' | 'https';
  contentType?: 'application/json';
  host?: string;
  onChange: (key: string[], val: any, set?: boolean) => void;
}
const Configuration: FC<ConfigurationProps> = ({ isEditable, onChange, protocol = 'https', contentType, host }) => (
  <FlexLayout p="xxl" flexDirection="column">
    <H4 fontWeight="semiBold" fontSize="xl">
      Configuration
    </H4>
    <Protocol protocol={protocol} onChange={onChange} isEditable={isEditable} />
    <ContentType contentType={contentType || 'application/json'} onChange={onChange} isEditable={isEditable} />
    <Host protocol={protocol} host={host} onChange={onChange} isEditable={isEditable} />
  </FlexLayout>
);

export default Configuration;
